// Styles CSS pour les effets high-tech de la Cartographie Globale
export const highTechStyles = `
  @keyframes pulse-glow {
    0%, 100% { box-shadow: 0 0 5px rgba(59, 130, 246, 0.5), 0 0 10px rgba(59, 130, 246, 0.3); }
    50% { box-shadow: 0 0 20px rgba(59, 130, 246, 0.8), 0 0 30px rgba(59, 130, 246, 0.5); }
  }
  
  @keyframes scan-line {
    0% { transform: translateY(-100%); }
    100% { transform: translateY(100%); }
  }
  
  @keyframes data-flow {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  
  @keyframes border-flow {
    0% { border-color: rgba(59, 130, 246, 0.3); }
    50% { border-color: rgba(139, 92, 246, 0.6); }
    100% { border-color: rgba(59, 130, 246, 0.3); }
  }
  
  @keyframes node-pulse {
    0%, 100% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.2); opacity: 0.7; }
  }
  
  .high-tech-card {
    background: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.9) 100%);
    border: 1px solid rgba(59, 130, 246, 0.3);
    animation: border-flow 3s ease-in-out infinite;
    position: relative;
    overflow: hidden;
  }
  
  .high-tech-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.8), transparent);
    animation: scan-line 3s linear infinite;
  }
  
  .cyber-grid {
    background-image: 
      linear-gradient(rgba(59, 130, 246, 0.1) 1px, transparent 1px),
      linear-gradient(90deg, rgba(59, 130, 246, 0.1) 1px, transparent 1px);
    background-size: 20px 20px;
  }
  
  .data-stream {
    background: linear-gradient(90deg, #3b82f6, #8b5cf6, #06b6d4, #3b82f6);
    background-size: 300% 100%;
    animation: data-flow 3s ease infinite;
  }
  
  .node-active {
    animation: node-pulse 2s ease-in-out infinite;
  }
  
  .hologram-effect {
    background: linear-gradient(180deg, rgba(59, 130, 246, 0.1) 0%, transparent 50%, rgba(139, 92, 246, 0.1) 100%);
  }
`;
